import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";

import { AteneaModule } from "@atenea-cms";
import { CountriesRoutes } from "./countries.routes";
import { CountryListComponent } from "./country-list/country-list.component";
import { CountryFormComponent } from "./country-form/country-form.component";
import { CountryService, CountryFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AteneaModule,
    CountriesRoutes,
  ],
  declarations: [CountryListComponent, CountryFormComponent],
  providers: [CountryService, CountryFormService],
})
export class CountriesModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/countries/countries.module.ts